<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div [ngClass]="isSmallScreen ? 'entry-3-small' : 'entry-3-modal'">
            <label>{{'mantenimiento-entidades-control.entidad.entidad' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div [ngClass]="isSmallScreen ? 'entry-3-small' : 'entry-3-modal'">
            <label>{{'global.bloqueoAutomaticoCertificado' | translate}} *</label>
            <app-filterable-list [itemsList]="bloqueoPorcentajes" [selectedItem]="newEditForm.get('bloqueoAutomaticoCertificado')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div [ngClass]="isSmallScreen ? 'entry-3-small' : 'entry-3-modal'">
            <label>{{'global.porcentajeBloqueo' | translate}}</label>
            <input type="text" formControlName="blockPercentage">
        </div>
        <div [ngClass]="isSmallScreen ? 'entry-3-small' : 'entry-3-modal'">
                <input type="checkbox" id="menuExpedicion" value="false" formControlName="menuExpedicion">
                <label for="menuExpedicion">{{'global.mostrarMenuExpediciones' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{entidadControl ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
</app-toast>